function n(n,r,t){return n>t?t:n<r?r:n}function r(n,r,t){return r+(n-r)*t}function t(n,r,t){return r===t?0:(n-r)/(t-r)}export{n as clamp,r as lerp,t as lerpInverse};
//# sourceMappingURL=index.module.js.map
